import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { getAgentCallSummary, getAgentLoginSummary } from '../../store/slices/dashboardSlice';
import AgentCallSummary from './AgentCallSummary';
import AgentLoginSummary from './AgentLoginSummary';

const Dashboard = () => {
  const dispatch = useDispatch();

  const agentCallSummaryGet = async () => {
    try {
      await dispatch(getAgentCallSummary()).unwrap();
    } catch (error) {
      console.log('error', error);
    }
  };

  const agentLoginSummaryGet = async () => {
    try {
      await dispatch(getAgentLoginSummary()).unwrap();
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    agentCallSummaryGet();
    agentLoginSummaryGet();
  }, []);

  return (
    <div>
      <Row>
        <Col md="7">
          <AgentCallSummary />
        </Col>
        <Col md="5">
          <AgentLoginSummary />
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
